import { Learner, Salutation } from "@hubcapp/types";
import { LearnerFormFields } from "@hubcapp/components/Cards/LearnerDetails/components/Modals/LearnerDetailsModal/types";

export const getInitialFormState = (
  learner: Partial<Learner> | undefined,
): LearnerFormFields => ({
  title: learner?.name?.title || Salutation.Mx,
  firstName: learner?.name?.firstName || "",
  lastName: learner?.name?.lastName || "",
  contactMobile: learner?.mobileNumber || "",
  contactEmail: learner?.emailAddress || "",
  addressLine1: learner?.pickupAddress?.line1 || "",
  addressLine2: learner?.pickupAddress?.line2 || "",
  addressTown: learner?.pickupAddress?.town || "",
  addressPostcode: learner?.pickupAddress?.postcode || "",
  dateOfBirth: new Date(learner?.dateOfBirth),
});
